import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    ViewChildren,
    ElementRef,
    ViewChild,
    ChangeDetectorRef
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormArray,
    Validators,
    FormControlName
} from '@angular/forms';


import { IProject, IPRoductionOffice, IProductionContact, IProjectContact, IProjectStatus } from './project.model';
import { GenericValidator } from "../shared/generic-validator";
import { ProjectService } from './project.service';
import { ActivatedRoute, Router, CanDeactivate } from '@angular/router';

import { AppService } from '../app.service';
import { ProjectValidator } from './project.validator';
import { Guid, DateUtils } from '../shared/utils';
import { NotificationsService, Notification } from '../shared/helper-components/index'

import { ProjectComponent } from './project.component';
import { FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { MessageBrokerService, ComponentCanDeactivate, AuthService } from '../shared/core/index';
import { ProjectItem } from './projectItem';
import { EventEmitter, HostListener } from '@angular/core';
import { ILookup, LookupList } from '../shared/lookup';
import { CIDocument, MassUpdateData } from "../clearance-item/clearance-item.model";
import { ClearanceItemAssetManagerComponent } from '../clearance-item/asset-management/clearance-item-asset-manager.component';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { ModalPromptComponent } from '../shared/helper-components/modal-prompt.component';
import { ModalPromptService, PromptOptions } from '../shared/helper-components/modal-prompt.service';
import { UserDepartmentService } from '../user-department/user-department.service';
import { IDepartment, IUserDepartment } from '../user-department/user-department.model';
import { StatusService } from '../status/status.service';
import { IStatus } from '../status/status.model';

import * as _ from 'lodash';
import { first } from 'rxjs/internal/operators/first';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { Location } from '@angular/common';

@Component({
    selector: 'project-detail',
    standalone: false,
    templateUrl: './project-detail.component.html',
    styleUrls: ['./project-detail.component.css']
})

export class ProjectDetailComponent implements OnInit, AfterViewInit, OnDestroy, ComponentCanDeactivate {

    @ViewChild('documentAsset', { static: false }) documentComponent: ClearanceItemAssetManagerComponent;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;

    pageTitle: string = 'Project Edit';
    errorMessage: string;
    projectForm: FormGroup;
    project: IProject = new IProject();
    sub: Subscription;
    error: string = '';
    SaveLabel: string = 'Save';
    // Use with the generic validation message class
    displayMessage: { [key: string]: string } = {};
    titles: ILookup[];
    tags: ILookup[];
    params = []
    documents: CIDocument[] = [];
    massUpdateData: MassUpdateData;
    openedProject: ProjectItem;
    userDepartments: IDepartment[];
    departmentStatuses : IStatus[];
    divisions: string[] = ['20th Century Studios', 'Searchlight Pictures', 'Walt Disney Studios Motion Pictures'];

    constructor(private _projectService: ProjectService,
        private _appService: AppService,
        private _fb: FormBuilder,
        private _route: ActivatedRoute,
        private _router: Router,
        private _notificationsService: NotificationsService,
        private _messageBrokerService: MessageBrokerService,
        private _errorHandler: GlobalErrorHandler,
        private _prompt: ModalPromptService,
        private _userDepartmentService: UserDepartmentService,
        private _statusService: StatusService,
        public _authService: AuthService,
        private _cdr: ChangeDetectorRef,
        private _location: Location,
    ) {

        // Defines all of the validation messages for the form.
        // These could instead be retrieved from a file or database.
        this.validationMessages = {
            name: {
                required: 'Please Enter the Project Name.',
                maxlength: 'Project Name Cannot be Longer than 255 Characters',
                projectTaken: 'Project Name is Already Taken'
            },
            keyCode: {
                required: 'Please Enter the Key Code for the Project.',
                minlength: 'Key Code Must be at Least 2 Characters Long',
                maxlength: 'Key Code Cannot be Longer than 4 Characters',
                projectTaken: 'Key Code is Already Taken'
            }
        };

        // Define an instance of the validator for use with this form, 
        // passing in this form's set of validation messages.
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    //this to keep track of each default selected prod office or contact
    currentProductionOffice: string = Guid.MakeNew().ToString();
    currentProductionContact: string = Guid.MakeNew().ToString();
    currentProjectContact: string = Guid.MakeNew().ToString();
    currentProjectStatus: string = Guid.MakeNew().ToString();

    //it persists the default prod office or contact onto the form
    defaultProductionOffice: FormControl;
    defaultProductionContact: FormControl;
    defaultProjectContact: FormControl;
    defaultProjecStatus: FormControl;

    promptOptions: PromptOptions = {header: 'Delete Project', body: ''};
    promptSubscription: Subscription;

    openModal() {
        this.promptOptions.body = 'Are you sure you want to delete \'' + this.project.name + '\'?';
        
        this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).pipe(first())
        .subscribe(
            answerWasYes=> {
                if(answerWasYes){
                    this.deleteProject(this.project.id);
                }
        });
    }

    ngOnInit(): void {

        this.projectForm = this._fb.group({
            id: '',
            name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(255)], ProjectValidator.checkProjectName(false)],
            keyCode: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(4)], ProjectValidator.checkProjectName(true)],
            wprBillingCode: '',
            wrapDate: null,
            startDate: null,
            releaseDate: null,
            productionOffices: this._fb.array([this.initProductionOffice(this.currentProductionOffice, true)]),
            productionContacts: this._fb.array([this.initProductionContacts(this.currentProductionContact, true)]),
            projectContacts: this._fb.array([this.initProjectContacts()]),
            projectStatuses: this._fb.array([]),
            comments: '',
            documents: this._fb.array([]),
            department: '',
            division: '',
            customStatus: false
        });

        this.defaultProductionOffice = new FormControl();
        this.projectForm.addControl('defaultProductionOffice', this.defaultProductionOffice);
        this.defaultProductionContact = new FormControl();
        this.projectForm.addControl('defaultProductionContact', this.defaultProductionContact);
        this.defaultProjectContact = new FormControl();
        this.projectForm.addControl('defaultProjectContact', this.defaultProjectContact);
        this.defaultProjecStatus = new FormControl();
        this.projectForm.addControl('defaultProjectStatus', this.defaultProjecStatus);

        this.syncCustomStatusDisabledState();

        //we'd like to know the 'current'/valid project (especially when 'adding' a new project to revert in case there is a change of mind)
        this.subScribeProjectNameChanges();       

        // Read the product Id from the route parameter
        this.sub = this._route.params.subscribe(
            params => {
                let id = params['projectId'];
                this.getDepartments(id);
                if (id) {
                    this.getProject(id);
                } else {
                    this.getLookups('');                   
                    this.pageTitle = 'New Project';
                    let p = new ProjectItem('', '[Adding New Project]');
                    this._appService.updateDisplayName('[Adding New Project]');
                }
            }
        );

    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        if (this.promptSubscription  && !this.promptSubscription.closed)
            this.promptSubscription.unsubscribe();
        //the following is to put back the previous project in case nothing gets changed when a new one is attempted to ad
        //if project.id is not set, it means the project was not saved (and it's NOT an existing one)
        if (!this.project.id){
            this._messageBrokerService.setCurrentProject(this.openedProject);
        }
    }

    ngAfterViewInit() {
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

        this.defaultProductionOffice.valueChanges.subscribe(data => {
            this.currentProductionOffice = data;
        });

        this.defaultProductionContact.valueChanges.subscribe(data => {
            this.currentProductionContact = data;
        });

        this.defaultProjectContact.valueChanges.subscribe(data => {
            this.currentProjectContact = data;
        });

        this.defaultProjecStatus.valueChanges.subscribe(data => {
            this.currentProjectStatus = data;
        });

        merge(this.projectForm.valueChanges, ...controlBlurs)
            .pipe(
                debounceTime(500)
            )
            .subscribe(value => {
                DateUtils.normalizeMaterialDateControls(this.projectForm, ['startDate', 'wrapDate', 'releaseDate']);
                this.displayMessage = this.genericValidator.processMessages(this.projectForm);
            });
    }

    @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        let isFormClean = !this.projectForm.dirty;
        return isFormClean;
    }

    subScribeProjectNameChanges(): void {
        this._messageBrokerService.getCurrentProject().subscribe((project: ProjectItem) => {
            if (project != null) {
                this.openedProject = project;
                if (!project.ProjectId) {
                    console.error('Could not detect an opened project!... ');
                }
            }
        }).unsubscribe();
    }

    get productionOffices(): FormArray {
        return <FormArray>this.projectForm.get('productionOffices');
    }

    get productionContacts(): FormArray {
        return <FormArray>this.projectForm.get('productionContacts');
    }

    get projectContacts(): FormArray {
        return <FormArray>this.projectForm.get('projectContacts');
    }

    get projectStatuses(): FormArray {
        return <FormArray>this.projectForm.get('projectStatuses');
    }

    initProductionContacts(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primarypc: primaryId,
            title: '',
            name: '',
            phoneNumber: '',
            phoneNumber2: '',
            phoneNumber3: '',
            email: ['',[Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+')]],
        });
    }

    initProductionOffice(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primary: primaryId,
            entity: '',
            address: '',
            phoneNumber: ''
        });

    }

    initProjectContacts(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primarypo: primaryId,
            name: '',
            title: '',
            email: ['',[Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+')]],
            emailNotification: false,
            selected : false,
            phoneNumber:'',
            tags: []
        });
    }

    initProjectContactsAdded(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primarypo: primaryId,
            name: '',
            title: 'Project Contact title',
            email: ['',[Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+')]],
            emailNotification: false,
            selected : false,
            phoneNumber:'',
            tags: []
        });
    }

    initProjectStatuses(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            statusId: 0,
            statusName: ['', [Validators.required, this.duplicateStatusDepartmentValidator(), this.duplicateStatusValidator()]],
            statusGroup: '',
            sortOrder: [null,Validators.pattern('^[0-9]+$')]
        });
    }

    duplicateStatusDepartmentValidator = () => {
        return (control: AbstractControl): ValidationErrors | null => {
            const trimmedValue = (control.value || '').trim().toLowerCase();

            if (!this.departmentStatuses || !this.departmentStatuses.length) {
                return null;
            }

            const duplicate = this.departmentStatuses.some(
            s => s.statusName && s.statusName.trim().toLowerCase() === trimmedValue
            );

            return duplicate ? { duplicateStatus: true } : null;
        };
    };

    duplicateStatusValidator = () => {
        return (control: AbstractControl): ValidationErrors | null => {
            var formArray = <FormArray>this.projectForm.get('projectStatuses');

            const duplicateCount = formArray.controls.filter(group => {
            const name = (group.get('statusName').value || '').trim().toLowerCase();
                return name === control.value;
            }).length;

            return duplicateCount > 1 ? { duplicateStatusInProject: true } : null;
        };
    };

    addProductionOffice(): void {
        let newPo = this.initProductionOffice(Guid.MakeNew().ToString());
        this.productionOffices.push(newPo);
    }

    addProductionContact(): void {
        let newPC = this.initProductionContacts();
        this.productionContacts.push(newPC);
    }

    addProjectContact(): void {
        let newPC = this.initProjectContactsAdded();
        this.projectContacts.push(newPC);
    }

    addProjectStatus(): void {
        let newPC = this.initProjectStatuses();
        this.projectStatuses.push(newPC);
    }

    resetDefaultRecord(control: FormArray, defaultField: string, currentIndex) {
        if (control.value[currentIndex].id === this.projectForm.get(defaultField).value) {
            if (control.length > 1) {
                this.projectForm.get(defaultField).patchValue(control.value[currentIndex + 1].id);
            }
        }

    }
    removeProductionOffice(i: number): void {
        const control = <FormArray>this.projectForm.controls['productionOffices'];
        this.resetDefaultRecord(control, 'defaultProductionOffice', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    removeProductionContact(i: number): void {
        const control = <FormArray>this.projectForm.controls['productionContacts'];
        this.resetDefaultRecord(control, 'defaultProductionContact', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    removeProjectContact(i: number): void {
        const control = <FormArray>this.projectForm.controls['projectContacts'];
        this.resetDefaultRecord(control, 'defaultProjectContact', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    removeProjectStatus(i: number): void {
        const control = <FormArray>this.projectForm.controls['projectStatuses'];
        this.resetDefaultRecord(control, 'defaultProjectStatus', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    ProductionOfficeSelected(selectedItem) {
        this.currentProductionOffice = selectedItem.value.id;
        this.projectForm.controls.defaultProductionOffice.setValue(selectedItem.value.id);
    }

    ProductionContactSelected(selectedItem) {
        this.currentProductionContact = selectedItem.value.id;
        this.projectForm.controls.defaultProductionContact.setValue(selectedItem.value.id);
    }

    ProjectContactSelected(selectedItem) {
        this.currentProjectContact = selectedItem.value.id;
        this.projectForm.controls.defaultProjectContact.setValue(selectedItem.value.id);
    }

    ProjectStatusSelected(selectedItem) {
        this.currentProjectStatus = selectedItem.value.id;
        this.projectForm.controls.defaultProjectStatus.setValue(selectedItem.value.id);
    }


    getProject(id: string): void {
        this._projectService.getProject(id)
            .subscribe(
            (project: IProject) => this.onProjectRetrieved(project),
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );

    }

    getLookups(department: string): void {
        this._projectService.getLookups(department)
            .subscribe(
            (list: LookupList[]) => {
                this.titles = [];
                this.tags = [];

                list.find(it => it.lookupType == 'titles').lookupData.forEach(
                    look => { this.titles.push(new ILookup(look.id, look.name));                        
                });
                list.find(it => it.lookupType == 'Tags').lookupData.forEach(
                    look => { this.tags.push(new ILookup(look.id, look.name));                        
                });           
            },
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );

    }

    saveProject(): void {
        DateUtils.normalizeMaterialDateControls(this.projectForm, ['startDate', 'wrapDate', 'releaseDate']);

        if (this.projectForm.dirty && this.projectForm.valid) {
            // Copy the form values over the product object values
            let p = <IProject>Object.assign({}, this.project, this.projectForm.value);

            var isNew: boolean = (p.id === '');

            p.startDate = DateUtils.toApiDate(p.startDate);
            p.wrapDate = DateUtils.toApiDate(p.wrapDate);
            p.releaseDate = DateUtils.toApiDate(p.releaseDate);

            this._projectService.saveProject(p)
                .subscribe(
                (p) => this.onSaveComplete(p, isNew),
                (error: any) => {
                
                    var e = JSON.stringify(error);
                    if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
                    }else{
                        this.errorMessage = <any>error;
                        this._errorHandler.processError(error);
                    }
                });
        } else if (!this.projectForm.dirty) {
            //this should not be
            this.onSaveComplete(null, false);
        } else {
            // Keep button behavior permissive, but provide clear feedback when form is invalid.
            this.projectForm.markAllAsTouched();
            this.displayMessage = this.genericValidator.processMessages(this.projectForm);
            this._notificationsService.add(new Notification('error', 'Please complete required fields before saving.'));
        }
    }

    deleteProject(id: string): void {
        this._projectService.deleteProject(id)
            .subscribe(
            (r) => {
                if (r) {
                    console.log('projectDetailComponent.deleteProject(...) >> response: ' + JSON.stringify(r));
                    this.onDeleteComplete(id);
                }
                (error: any) => {
                    // console.error('projectDetailComponent.deleteProject(...) >> error:' + error);
                    this.errorMessage = <any>error;
                    this._errorHandler.processError(error);                    
                }
            }
            );

    }

    onProjectRetrieved(project: IProject): void {
        let productionOffices = <FormArray>this.projectForm.controls['productionOffices'];
        let productionContacts = <FormArray>this.projectForm.controls['productionContacts'];
        let projectContacts = <FormArray>this.projectForm.controls['projectContacts'];
        let projectStatuses = <FormArray>this.projectForm.controls['projectStatuses'];

        if (this.projectForm) {
            this.projectForm.reset();
            //reinit these values 
            this.currentProductionOffice = Guid.MakeNew().ToString();
            this.currentProductionContact = Guid.MakeNew().ToString();
            productionOffices.controls.pop();
            productionContacts.controls.pop();
            projectContacts.controls.pop();
            projectStatuses.controls.pop();
        }

        if (!project) {
            this.error = 'Could not find project. It may have been deleted (or deactivated)!';
            this._errorHandler.processError(this.error);            
            return;
        }


        this.titles = this._projectService.titles;
        this.tags = this._projectService.tags;

        this.project = project;

        this.pageTitle = `Project: ${this.project.name}`;

        // Legacy Project Detail footer / header action label is "Save" (not "Save Changes").
        this.SaveLabel = 'Save';
        this.projectForm.get('department').setValue(project.department);
        this.refreshDepartmentSelect();

        this.projectForm.controls.name.clearAsyncValidators();
        this.projectForm.controls.name.setAsyncValidators(ProjectValidator.checkProjectName(false, this.project.name));

        this.projectForm.controls.keyCode.clearAsyncValidators();
        this.projectForm.controls.keyCode.setAsyncValidators(ProjectValidator.checkProjectName(true, this.project.keyCode));

        // Update the data on the form
        this.projectForm.patchValue({
            id: this.project.id,
            name: this.project.name,
            keyCode: this.project.keyCode,
            wprBillingCode: this.project.wprBillingCode,
            comments: this.project.comments,
            startDate: DateUtils.toFormDate(this.project.startDate),
            wrapDate: DateUtils.toFormDate(this.project.wrapDate),
            releaseDate: DateUtils.toFormDate(this.project.releaseDate),
            defaultProductionOffice: this.project.defaultProductionOffice ? this.project.defaultProductionOffice : this.currentProductionOffice,
            defaultProductionContact: this.project.defaultProductionContact ? this.project.defaultProductionContact : this.currentProductionContact,
            defaultProjectContact: this.project.defaultProjectContact ? this.project.defaultProjectContact : this.currentProjectContact,
            customStatus: this.project.customStatus,
            division: this.project.division
        });
        this.syncCustomStatusDisabledState();

        //push a new default production office if none found on the project itself
        if (this.project.productionOffices.length == 0) {
            let defaultPO = new IPRoductionOffice();
            defaultPO.id = this.currentProductionOffice;
            this.project.productionOffices.push(defaultPO);
        }

        //if so, init the array
        this.project.productionOffices.forEach(po => {
            const fb = this.initProductionOffice();
            fb.patchValue(po);
            productionOffices.push(fb);
        });

        if (this.project.productionContacts.length == 0) {
            let defaultPC = new IProductionContact();
            defaultPC.id = this.currentProductionContact;
            this.project.productionContacts.push(defaultPC);
        }

        if(this.project.projectStatuses.length == 0 && this.project.customStatus){
            let defaultStatus = new IProjectStatus();
            this.project.projectStatuses.push(defaultStatus);
        }

        this.project.productionContacts.forEach(app => {
            const fb = this.initProductionContacts();
            fb.patchValue(app);
            productionContacts.push(fb);
        });

        if (this.project.projectContacts.length == 0) {
            let defaultPCo = new IProjectContact();
            defaultPCo.id = this.currentProjectContact;
            
            this.project.projectContacts.push(defaultPCo);
        }

        this.project.projectContacts.forEach(app => {
            const fb = this.initProjectContacts();
             
            if(!(app.title === "Clearance Contact" || app.title === "Head of Department")){
                app.selected = true;
                app.emailNotification= false;
            }

            fb.patchValue(app);
            
            projectContacts.push(fb);
        });

        this.project.projectStatuses.forEach(app => {
            const fb = this.initProjectStatuses();
            fb.patchValue(app);
            fb.addControl('statusId', this._fb.control(app.statusId));
            projectStatuses.push(fb);
        });

        this.getDepartmentStatuses(project.department);

        if (this.documents && this.project.documents && this.project.documents.length > 0) {
            this.project.documents.forEach(doc => {
                var existingImage = this.documents.find(it => it.id == doc.id);
                this.documents.push(doc);
            });
        }

        let docs = <FormArray>this.projectForm.controls['documents']

        if (docs && docs.controls && docs.controls.length > 0) {
            docs.controls = [];
        }
        if (this.documents)
            this.documents.forEach(doc => {
                const fb = this.documentComponent.initAsset(doc);
                fb.patchValue(doc);
                docs.push(fb);
            });
        docs.updateValueAndValidity();


        this.projectForm.controls.name.updateValueAndValidity();
        this.pageTitle = '';
        this.projectForm.patchValue({
            documents: this.documentComponent.initAssets()
        }, { emitEvent: false });

        // Load/populate must leave the form pristine so Save stays disabled until the user edits.
        this.projectForm.markAsPristine();
        this.projectForm.markAsUntouched();
        this._cdr.markForCheck();
    }

    /** Legacy: Save enabled only when the form is valid and dirty. */
    get canSave(): boolean {
        return !!(this.projectForm && this.projectForm.valid && this.projectForm.dirty);
    }

    onSaveComplete(newProject: IProject, isNew: boolean): void {

        
        if (!newProject) {
            console.log('Error');
            return;
        }

        console.log('ProjectDetailComponent.OnSaveComplete >> saved project:' + JSON.stringify(newProject));

        this.projectForm.markAsPristine();

        this._router.navigate(['dashboard', newProject.id]);
        this._notificationsService.add(new Notification('success', newProject.name + ' was ' + (isNew ? 'added' : 'updated') + ' successfully'));
        
        this._messageBrokerService.setCurrentProject(new ProjectItem(newProject.id, newProject.name));

    }

    onDeleteComplete(id: string): void {
        this._messageBrokerService.setDeletedProject(id);
        this._router.navigate(['dashboard']);
        this._notificationsService.add(new Notification('success', 'Project \'' + this.project.name + '\' has been successfully deleted'));
    }

    goBack(): void {
        this._location.back();
    }

    onCustomStatusToggle(event: any): void {
        const isCustom = event.checked;

        if (isCustom && this.projectStatuses.length === 0) {
            this.addProjectStatus();
        }
    }

    /** Keep Custom statuses toggle in sync with readOnly via FormControl API (TA-007 / TR-007). */
    private syncCustomStatusDisabledState(): void {
        const ctrl = this.projectForm && this.projectForm.get('customStatus');
        if (!ctrl) {
            return;
        }
        if (this._authService.readOnly) {
            ctrl.disable({ emitEvent: false });
        } else if (ctrl.disabled) {
            ctrl.enable({ emitEvent: false });
        }
    }

    onDepartmentChange(event: any): void {
        const selectedValue = event.value;

        this.getLookups(selectedValue);

        this.getDepartmentStatuses(selectedValue);
    }

    getDepartments(id: string): void {
        this._userDepartmentService.getDepartments()
            .subscribe(
            (userDepartments: IUserDepartment) => {
                this.userDepartments = userDepartments.userDepartments;
                // Options must exist in the view before mat-select can show the value.
                this._cdr.detectChanges();
                if (!id) {
                    this.projectForm.get('department').setValue(
                        this.userDepartments[0].department);
                    this.getDepartmentStatuses(this.userDepartments[0].department);
                } else {
                    this.refreshDepartmentSelect();
                }
            },
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );
    }

    /**
     * Re-apply department after mat-options exist so MDC mat-select shows the trigger text.
     * Value can be set before userDepartments load; a later click used to paint it.
     */
    private refreshDepartmentSelect(): void {
        const departmentCtrl = this.projectForm && this.projectForm.get('department');
        const current = departmentCtrl && departmentCtrl.value;
        if (!current || !this.userDepartments || !this.userDepartments.length) {
            return;
        }
        departmentCtrl.setValue(current, { emitEvent: false });
        this._cdr.detectChanges();
    }

    getDepartmentStatuses(department: string): void {
        this._statusService.getDepartmentStatuses(department)
            .subscribe(
            (statuses: IStatus[]) => {
                this.departmentStatuses = statuses;
            },
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );
    }
}
